// The backend stores photo paths as relative URLs (e.g. "/uploads/vehicles/1/photo.jpg").
// This converts that into a full URL the browser can actually load,
// using the same base URL as our API calls.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export function getFullPhotoUrl(relativePath) {
  if (!relativePath) return null;
  return `${API_BASE_URL}${relativePath}`;
}